/* <pdp-marquee>: keeps the loop seamless when the item list is shorter than the viewport by cloning the track,
   and pauses when off-screen. Pure CSS does the motion. */
if (!customElements.get('pdp-marquee')) {
  class PdpMarquee extends HTMLElement {
    connectedCallback() {
      this.ac = new AbortController();
      this.fill();
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { this.querySelectorAll('.pd-marquee__track').forEach((t) => { t.style.animationPlayState = e.isIntersecting ? 'running' : 'paused'; }); });
      });
      this.io.observe(this);
      window.addEventListener('resize', () => this.fill(), { signal: this.ac.signal, passive: true });
    }
    disconnectedCallback() { this.ac.abort(); if (this.io) this.io.disconnect(); }
    fill() {
      const tracks = this.querySelectorAll('.pd-marquee__track');
      if (tracks.length < 2) return;
      const base = tracks[0];
      // remove earlier clones beyond the second track
      Array.from(tracks).slice(2).forEach((t) => t.remove());
      const w = base.getBoundingClientRect().width;
      if (!w) return;
      let total = w * 2, guard = 0;
      while (total < this.clientWidth * 2 && guard < 6) {
        const clone = tracks[1].cloneNode(true);
        this.appendChild(clone);
        total += w; guard += 1;
      }
    }
  }
  customElements.define('pdp-marquee', PdpMarquee);
}
